export default function SecondaryNav() {

    document.querySelectorAll('.secondary-nav').forEach((el, i) => {

        el.style.zIndex = 999 - i;

        let mobileMenuToggler = el.querySelector('.secondary-nav-button');

        mobileMenuToggler.addEventListener('click', function(){
            this.classList.toggle('is-open');
        })

    });
}
